<template>
  <article class="EventCardPrimary">
    <image-vue class="EventCardPrimary-img" :width="987" :height="480" :imgId="imgId" :alt="imgAlt" />

    <div class="EventCardPrimary-count">
        <div class="EventCardPrimary-segment">
            <strong class="EventCardPrimary-segmentValue">{{remaining.days}}</strong>
            <span class="EventCardPrimary-segmentLabel">Days</span>
        </div>
        <div class="EventCardPrimary-segment">
            <strong class="EventCardPrimary-segmentValue">{{remaining.hours}}</strong>
            <span class="EventCardPrimary-segmentLabel">Hrs</span>
        </div>
        <div class="EventCardPrimary-segment">
            <strong class="EventCardPrimary-segmentValue">{{remaining.minutes}}</strong>
            <span class="EventCardPrimary-segmentLabel">Mins</span>
        </div>
        <div class="EventCardPrimary-segment">
            <strong class="EventCardPrimary-segmentValue">{{remaining.seconds}}</strong>
            <span class="EventCardPrimary-segmentLabel">Secs</span>
        </div>
    </div>

    <div class="EventCardPrimary-body">
      <time class="EventCardPrimary-date">{{formattedDate}}</time> 
      <h3 class="EventCardPrimary-title">{{title}}</h3>
      <p class="EventCardPrimary-desc" v-html="shortDesc"></p>
      <p v-if="price" class="u-font-size-lg"><strong>From {{price}} {{ticketsFromPostfix}}</strong></p>
      <button-vue label="View details" :href="href"/>
    </div>
    
    <div class="EventCardPrimary-overlay"></div>    
  </article>
</template>

<script>
import Image from '../UI/Image.vue';
import ButtonVue from '../UI/Button.vue';
import getRemainingTime from '../../../../utils/get-remaining-time';
import {formatInterval} from "../../../../utils/dates";
import {isNil} from "lodash";

export default {
  components: { 'image-vue': Image, ButtonVue },
  props: {
    href: String,
    imgId: Number,
    imgAlt: String,
    startDate: String,
    endDate: String,
    title: String,
    desc: String,
    shortDesc: String,
    price: String,
    ticketsFromPostfix: String
  },

  data() {
    return ({
      remaining: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      }
    });
  },

  computed: {
    formattedDate() {
      return formatInterval(this.startDate, this.endDate);
    }
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        const date = new Date(this.startDate);
        const remaining = getRemainingTime(date);

        if(isNil(remaining)) {
          this.stopTimer();
          return;
        }
        
        Object.keys(remaining).forEach(key => 
          remaining[key] = remaining[key].toString().padStart(2, '0')
        );
        
        this.remaining = remaining;
      }, 1000);
    },

    stopTimer() {
      clearInterval(this.timer);
    }
  }
}
</script>